module.exports = __webpack_public_path__ + "img/horizontal_3_4_0.8f3236a6.png";